@if (displayModeChangeVisible) {
<div class="flex justify-content-end mb-2">
  <p-selectButton
    [options]="modeOptions"
    [(ngModel)]="displayMode"
    optionLabel="icon"
    optionValue="value"
  >
    <ng-template let-item pTemplate>
      <i [class]="item.icon"></i>
    </ng-template>
  </p-selectButton>
</div>
}

<!---->
@if (render && stepperVisible) {
<!-- <div class="grid">
  <div class="max-h-30rem col-12 md:col-4"> -->
<div class="grid">
  <div class="max-h-30rem overflow-y-auto col-12 md:col-4">
    <p-panelMenu [model]="groupLists">
      <ng-template let-item pTemplate="item">
        @if(item.items?.length > 0){
        <div class="flex gap-2 align-items-center text-sm cursor-pointer p-2">
          <i class="pi pi-chevron-{{ item?.expanded ? 'up' : 'down' }}"></i>
          {{ item.label }}
        </div>
        } @else{
        <div
          class="flex gap-2 align-items-center text-sm cursor-pointer p-2"
          [ngClass]="{
            'font-semibold bg-gray-100 text-blue-500':
              item.id === selectedFormPanel?.name,
            'text-green-600': isGroupItemValid(item.id)
          }"
          (click)="onGroupItemClick(item)"
        >
          <i
            class=" {{
              item.icon ?? isGroupItemValid(item.id)
                ? 'pi pi-check bg-green-600 text-white text-xs p-1'
                : 'pi pi-circle text-xl'
            }} border-circle "
          ></i>
          {{ item.label }}
        </div>
        }
      </ng-template>
    </p-panelMenu>
  </div>

  <div class="flex flex-column col-12 md:col-8">
    @if (config?.formConfig?.config?.length != 0) {
    <div [style.margin-top.px]="-15" class="mr-2">
      <eo-form
        #eoForm
        [config]="config!.formConfig!"
        displayMode="groupLists"
      />
    </div>
    }

    <!---->
    @for(config of config?.formTableConfigs; track config.id){
    @if(isFormTableVisible(config)) {
    <div
      class="border-round-lg border-1 border-gray-50 bg-gray-50 ml-3"
      [style.margin-top.px]="-20"
    >
      <eo-form-table
        #eoFormTable
        [config]="config"
        (onDeleteItem)="onDeleteClick($event)"
      />
    </div>
    } }
  </div>
</div>
}

<!-- STATIC CONTENT --->
<ng-content />
